export enum LayerGroupKind {
  SOIL_SAMPLE = 'soilSample',
  ZONE_STRENGTH = 'zoneStrength',
  TRIMBLE_ZONE_STRENGTH = 'trimbleZoneStrength',
  PROPLANTA_EXPERT_ADVICE = 'proplantaExpertAdvice',
  SELF_ZONE = 'selfZone',
  ZONING = 'zoning',

  PESTICIDE_PLAN = 'pesticidePlan',
  SEED_PLAN = 'seedPlan',
  FERTILIZER_PLAN = 'fertilizerPlan',

  YIELD = 'yield',
  CELL_YIELD = 'cellYield',
  CLAS_CELL_YIELD = 'clasCellYield',

  FERTILIZING = 'fertilizing',
  PESTICIDE = 'pesticide',
  SEEDING = 'seeding',

  FERTILIZATION_PLAN = 'fertilizationPlan',

  PRECISION_AGRICULTURE_AREA_SELECTION = 'precisionAgricultureAreaSelection',

  YIELD_ZONE_STRENGTH = 'yieldZoneStrength',
  SOIL_TEMPERATURE = 'soilTemperature',
  VANTAGE_YIELD = 'vantageYield',
  APPLIED_DOSE = 'appliedDose',

  STATISTICS_YIELD_ZONE_STRENGTH = 'statisticYieldZoneStrength',
  STATISTICS_YIELD_STEM_NUMBER = 'statisticYieldStemNumber',
  STATISTICS_YIELD_SOIL_PARAMETER = 'statisticYieldSoilParameter',
  STATISTICS_YIELD_APPLIED_DOSE = 'statisticYieldAppliedDose',
  STATISTICS_DECISION_SUPPORT = 'statisticDecisionSupport',

  INCLINE_DETECTION = 'inclineDetection',

  TILLAGE = 'tillage'
}
